// extracted by mini-css-extract-plugin
module.exports = {"title":"Lineup_title__117-z","titleContainer":"Lineup_titleContainer__27bCd","animation":"Lineup_animation__2RDp6","moveDown":"Lineup_moveDown__z6NSm"};